module.exports = __webpack_public_path__ + "static/media/voltgroom-5.0e9e36f2.jpg";